import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class CalculosImportacionService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/calculo-importacion/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/anbe-dev/src/app/shared/services/api/calculos-importacion.service.ts